import React from 'react'
import Card from '@mui/material/Card'
import CardHeader from '@mui/material/CardHeader'
import IconButton from '@mui/material/IconButton'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import ExpandLessIcon from '@mui/icons-material/ExpandLess'
import Collapse from '@mui/material/Collapse'
import { compose } from 'recompose'

export const Filter = ({ filterObj, filterState, setFilterState, content, title, subtitle }) => (
	<Card
		sx={{
			position: 'relative',
			zIndex: 99,
			boxShadow: filterState.expanded
				? 'rgba(0, 0, 0, 0.16) 0px 3px 10px, rgba(0, 0, 0, 0.23) 0px 3px 10px'
				: 'none',
		}}
	>
		<CardHeader
			title={title}
			subheader={subtitle}
			onClick={() => setFilterState({ ...filterObj, expanded: !filterState.expanded })}
			titleTypographyProps={{
				fontSize: '16px',
				fontWeight: 600,
				color:'rgba(0, 0, 0, 0.87)'
			}}
			subheaderTypographyProps={{
				fontSize: '12px',
				color:'rgba(0, 0, 0, 0.54)'
			}}
			sx={{
				backgroundColor: '#f3f3f3',
				overflow: 'hidden',
				cursor:'pointer',
				'@media (min-width: 600px)': { paddingLeft: '24px' }
			}}
			action={
				<IconButton
					aria-label="Show more"
					onClick={() => setFilterState({ ...filterObj, expanded: !filterState.expanded })}
				>
					{!filterState.expanded && <ExpandMoreIcon />}
					{filterState.expanded && <ExpandLessIcon />}
				</IconButton>
			}
		/>
		<Collapse
			in={filterState.expanded}
			timeout="auto"
			unmountOnExit
			onExited={() => setFilterState({ ...filterObj, expanded: false })}
			onEntered={() => setFilterState({ ...filterObj, expanded: true })}
		>
			{content}
		</Collapse>
	</Card>
)

export default Filter
